import { apiRequest, invalidateCache } from '../../shared/api/base'

export interface Invite {
  id: string
  email: string
  status: 'pending' | 'approved' | 'rejected'
  notes: string | null
  requested_at: string
  approved_at: string | null
  invited_by: string | null
  approved_by: string | null
}

export async function getAdminStatus(): Promise<{ isAdmin: boolean }> {
  return apiRequest<{ isAdmin: boolean }>('/admin/me')
}

export async function getInviteStatus(): Promise<{ status: string }> {
  return apiRequest<{ status: string }>('/admin/invite-status')
}

export async function getInvites(): Promise<Invite[]> {
  const res = await apiRequest<{ invites: Invite[] }>('/admin/invites')
  return res.invites
}

export async function addInvite(email: string, notes?: string): Promise<Invite> {
  const res = await apiRequest<{ invite: Invite }>('/admin/invites', {
    method: 'POST',
    body: JSON.stringify({ email, ...(notes ? { notes } : {}) }),
  })
  invalidateCache('/admin/invites')
  return res.invite
}

export async function updateInvite(id: string, status: 'approved' | 'rejected', notes?: string): Promise<Invite> {
  const res = await apiRequest<{ invite: Invite }>(`/admin/invites/${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ status, ...(notes !== undefined ? { notes } : {}) }),
  })
  invalidateCache('/admin/invites')
  return res.invite
}

export async function sendInviteEmail(id: string): Promise<void> {
  await apiRequest(`/admin/invites/${id}/send`, { method: 'POST' })
}

export async function removeInvite(id: string): Promise<void> {
  await apiRequest(`/admin/invites/${id}`, { method: 'DELETE' })
  invalidateCache('/admin/invites')
}

export interface CreateUserInput {
  email: string
  password: string
  firstName?: string
  lastName?: string
  assistantName?: string
  tier?: 'trial' | 'managed' | 'pro'
  trialDays?: number
  language?: 'en' | 'sv'
  notes?: string
  showOnboardingWizard?: boolean
  isAdmin?: boolean
}

export interface CreatedUser {
  id: string
  email: string
  firstName: string | null
  lastName: string | null
  tier: 'trial' | 'managed' | 'pro'
  trialEndsAt: string | null
  assistantName: string | null
}

export async function createUser(input: CreateUserInput): Promise<CreatedUser> {
  const res = await apiRequest<{ user: CreatedUser }>('/admin/users', {
    method: 'POST',
    body: JSON.stringify(input),
  })
  invalidateCache('/admin/invites')
  return res.user
}
